import './UsuarioItem.css';
import {useState} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import clienteAxios from '../../api/axios';

const UsuarioItem = ({ usuario, esAdministrador, onUsuarioActualizado }) => {


    /* MODAL Editar*/
    const [showEditar, setShowEditar] = useState(false);
    const handleCloseEditar = () => setShowEditar(false);
    const handleShowEditar = () => {
        setNombre(usuario.nombre);
        setContrasenia(usuario.contrasenia);
        setDescuento(usuario.descuento);
        setUtilidad(usuario.utilidad);
        setDescripcionCliente(usuario.descripcionCliente || '');
        setShowEditar(true);
    };
    
    /* MODAL Ok Editar*/
    const [showOkEditar, setShowOkEditar] = useState(false);
    const handleCloseOkEditar = () => setShowOkEditar(false);
    const handleShowOkEditar = () => setShowOkEditar(true);
    /* MODAL Eiminar*/
    const [showEliminar, setShowEliminar] = useState(false);
    const handleCloseEliminar = () => setShowEliminar(false);
    const handleShowEliminar = () => setShowEliminar(true);
    /* MODAL Ok Eiminar*/
    const [showOkEliminar, setShowOkEliminar] = useState(false);
    const handleCloseOkEliminar = () => setShowOkEliminar(false);
    const handleShowOkEliminar = () => setShowOkEliminar(true);
    /* MODAL Fallida*/
    const [showFallida, setShowFallida] = useState(false);
    const handleCloseFallida = () => setShowFallida(false);
    const handleShowFallida= () => setShowFallida(true);

    const editarUsuario = (usuario) => {
        console.log('Editar usuario: ' + usuario.nombre);
        handleShowEditar();
    }
    const eliminarUsuario = (usuario) => {
        console.log('Eliminar usuario: ' + usuario.nombre);
        handleShowEliminar();
    }

    //Guardar nuevos datos del usuario
    const guardarNuevoUsuario = (usuario) => {
        console.log('Modificar usuario: ' + usuario.nombre);
        handleCloseEditar();
        const usuarioActualizado = {
            nombre,
            contrasenia,
            descripcionCliente,
            descuento,
            utilidad,
            idUsuario: usuario.idUsuario
        };
        
        console.log('Datos del usuario actualizados:', usuarioActualizado);
        
        clienteAxios.post('/usuario/actualizar', usuarioActualizado)
        .then(res => {
            console.log('Respuesta del servidor:', res.data);
            // Si el servidor responde "OK" (o 200 Exitoso)
            if (res.data === "OK" || res.status === 200) {
                handleShowOkEditar();
                onUsuarioActualizado(); // 🔥 refresca la tabla
            } else {
                handleShowFallida();
            }
        })
        .catch(err => {
            console.error('Error en la modificación:', err.response?.data || err.message);
            handleShowFallida();
        });
    }
    

    //Eliminar usuairo definitivamente
    const elimnarUsuarioDefinitivo = (usuario) => {
        console.log('Eliminar usuario: ' + usuario.nombre);
        handleCloseEliminar();
        
        clienteAxios.post('/usuario/eliminar', usuario)
        .then(() => {
            handleShowOkEliminar();
            onUsuarioActualizado(); // 🔥 refresca la tabla
        })           
        .catch(err => {
            console.error('Error al eliminar usuario:', err);
            handleShowFallida();
        });
    }

    const [nombre, setNombre] = useState('');
    const [contrasenia, setContrasenia] = useState('');
    const [descuento, setDescuento] = useState('');
    const [utilidad, setUtilidad] = useState('');
    const [descripcionCliente, setDescripcionCliente] = useState('');


    return (
        <tr>
            <td>{usuario.nombre}</td>
            <td>{usuario.contrasenia}</td>
            {esAdministrador() && <td>{usuario.descuento}</td>}
            <td>{usuario.utilidad}</td>
            <td><ion-icon name="create-outline" onClick={() => editarUsuario(usuario)}></ion-icon></td>
            <td><ion-icon name="trash-outline" onClick={() => eliminarUsuario(usuario)}></ion-icon></td>
            <td>{usuario.descripcionCliente}</td>
            {/* Modales */}
            <Modal show={showEditar} onHide={handleCloseEditar}>
                <Modal.Header closeButton>
                <Modal.Title>Modificar Usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Modificar Nombre:</Form.Label>
                            <Form.Control type="email" placeholder={usuario.nombre} id="usuario" value={nombre} onChange={(e) => {setNombre(e.target.value)}}/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Modificar Contraseña:</Form.Label>
                            <Form.Control type="text" placeholder={usuario.contrasenia}  id="contrasenia" value={contrasenia} onChange={(e) => {setContrasenia(e.target.value)}}/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formDescripcionCliente">
                            <Form.Label>Modificar descripción del cliente:</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={descripcionCliente}
                                onChange={(e) => setDescripcionCliente(e.target.value)}
                            />
                        </Form.Group>

                        {
                            esAdministrador() ? 
                            <Form.Group className="mb-3" controlId="formBasicDescuento">
                                <Form.Label>Modificar Descuento:</Form.Label>
                                <Form.Control type="number" placeholder={usuario.descuento} id="descuento" value={descuento} onChange={(e) => {setDescuento(e.target.value)}}/>
                            </Form.Group> :
                            <Form.Group className="mb-3" controlId="formBasicDescuento">
                                <Form.Label>Modificar Utilidad:</Form.Label>
                                <Form.Control type="number" placeholder={usuario.utilidad} id="descuento" value={utilidad} onChange={(e) => {setUtilidad(e.target.value)}}/>
                            </Form.Group>
                        }
                        <Button variant="outline-success" onClick={() => guardarNuevoUsuario(usuario)}>Editar Usuario</Button>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseEditar}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showOkEditar} onHide={handleCloseOkEditar}>
                <Modal.Header closeButton>
                <Modal.Title>Operación exitosa!</Modal.Title>
                </Modal.Header>
                <Modal.Body>El usuario fue modificado correctamente.</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseOkEditar}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showEliminar} onHide={handleCloseEliminar}>
                <Modal.Header closeButton>
                <Modal.Title>Eliminar Usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Esta seguro que desea elimnar al usuario {usuario.nombre}?</Modal.Body>
                <Modal.Footer>
                <Button variant="outline-danger" onClick={() => elimnarUsuarioDefinitivo(usuario)}>Eliminar Usuario</Button>
                <Button variant="secondary" onClick={handleCloseEliminar}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showOkEliminar} onHide={handleCloseOkEliminar}>
                <Modal.Header closeButton>
                <Modal.Title>Operación exitosa!</Modal.Title>
                </Modal.Header>
                <Modal.Body>El usuario fue eliminado correctamente.</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseOkEliminar}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showFallida} onHide={handleCloseFallida}>
                <Modal.Header closeButton>
                <Modal.Title>Operación fallida!</Modal.Title>
                </Modal.Header>
                <Modal.Body>La operación falló, vuelva a intentarlo.</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseFallida}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>
        </tr>
    );
}
export default UsuarioItem;